<div class="gradient-border flex aspect-square size-full items-center justify-center overflow-hidden rounded-full">
  <div class="bg-[#43878D]">
    <img src="assets/woordkr8/sprites/profile.png" class="y- translate-y-1/12 scale-125" />
  </div>
</div>
